// Header.jsx - COMPLET AVEC CHANGEMENT DE LANGUE FONCTIONNEL
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLangMenuOpen, setIsLangMenuOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState('fr');
  const { t } = useTranslation();

  // Icônes SVG inline
  const Icons = {
    Home: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
      </svg>
    ),
    Music: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
      </svg>
    ),
    Book: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"/>
      </svg>
    ),
    Worship: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
      </svg>
    ),
    School: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/>
      </svg>
    ),
    About: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
      </svg>
    ),
    Contact: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/>
      </svg>
    ),
    Support: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.78-1.18 2.73-3.12 3.16z"/>
      </svg>
    ),
    Menu: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
      </svg>
    ),
    Close: () => (
      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    ),
    Cross: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
      </svg>
    ),
    Globe: () => (
      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
      </svg>
    )
  };

  // Navigation items
  const navItems = [
    { path: '/', label: t('header.nav.home'), icon: <Icons.Home /> },
    { path: '/about', label: t('header.nav.about'), icon: <Icons.About /> },
    { path: '/music', label: t('header.nav.music'), icon: <Icons.Music /> },
    { path: '/books', label: t('header.nav.books'), icon: <Icons.Book /> },
    { path: '/worship', label: t('header.nav.worship'), icon: <Icons.Worship /> },
    { path: '/eaj', label: t('header.nav.eaj'), icon: <Icons.School /> },
    { path: '/support', label: t('header.nav.support'), icon: <Icons.Support /> },
    { path: '/contact', label: t('header.nav.contact'), icon: <Icons.Contact /> },
  ];

  // Langues disponibles
  const languages = [
    { code: 'fr', name: t('header.languages.french'), flag: 'FR' },
    { code: 'en', name: t('header.languages.english'), flag: 'EN' },
    { code: 'sv', name: t('header.languages.swedish'), flag: 'SV' }
  ];

  // Vérifie si un lien est actif
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  // Initialiser la langue au chargement
  useEffect(() => {
    const savedLang = localStorage.getItem('preferredLanguage') || 'fr';
    setCurrentLang(savedLang);
    i18n.changeLanguage(savedLang);
  }, []);

  // Changement de langue
  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode).then(() => {
      setCurrentLang(langCode);
      setIsLangMenuOpen(false);
      setIsMenuOpen(false);
      
      // Sauvegarder la langue dans localStorage
      localStorage.setItem('preferredLanguage', langCode);
      
      // Forcer le rechargement des traductions dans le Header
      // Note: Pas besoin de reload toute la page
      window.location.reload();
    }).catch((error) => {
      console.error('Erreur lors du changement de langue:', error);
    });
  };

  return (
    <>
      {/* Header Principal */}
      <header className="absolute top-0 left-0 right-0 z-50 bg-black border-b border-gray-800 pb-7 pr-8">
        <div className="container mx-auto px-4 ">
          <div className="flex items-center justify-between h-20 ">
            {/* Logo avec photo */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
              className="flex items-center space-x-3"
            >
              <div className="w-26 h-28 rounded-lg flex items-center justify-center overflow-hidden mt-5 ">
                <img 
                  src="/assets/images/EsaieMusiclogo.jpg" 
                  alt="Logo Esaie Wilondja"
                  className="w-full h-full object-cover"
                />
              </div>
              <Link to="/" className="group">
                <h1 className="text-xl font-bold text-white font-serif mt-5 pr-6 ">
                  Esaie<span className="text-yellow-500">Wilondja</span>
                </h1>
                <p className="text-xs text-gray-400 group-hover:text-yellow-500 transition-colors">
                  {t('header.ministry')}
                </p>
              </Link>
            </motion.div>

            {/* Navigation Desktop */}
            <nav className="hidden lg:flex items-center space-x-4 ">
              {navItems.map((item, index) => (
                <motion.div
                  key={item.path}
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.05 }}
                >
                  <Link
                    to={item.path}
                    className={`group relative px-4 py-2 rounded-lg transition-all duration-300 flex items-center  space-x-2 ${
                      isActive(item.path)
                        ? 'bg-yellow-900/30 text-yellow-500'
                        : 'text-gray-300 hover:text-yellow-500 hover:bg-gray-900/50'
                    }`}
                  >
                    <span className={`transition-transform duration-300  ${
                      isActive(item.path) ? 'scale-110' : 'group-hover:scale-110'
                    }`}>
                      {item.icon}
                    </span>
                    <span className="font-medium">{item.label}</span>
                    
                    {/* Indicateur actif */}
                    {isActive(item.path) && (
                      <motion.div
                        layoutId="activeIndicator"
                        className="absolute bottom-0 left-2/2 transform -translate-x-1/2 w-3/4 h-0.5 bg-yellow-500 rounded-full "
                        initial={false}
                        transition={{ type: "spring", stiffness: 380, damping: 30 }}
                      />
                    )}
                  </Link>
                </motion.div>
              ))}
            </nav>

            {/* Section droite avec langue et soutien */}
            <div className="flex items-center space-x-4">
              {/* Sélecteur de langue Desktop */}
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                className="relative hidden lg:block"
              >
                <button
                  onClick={() => setIsLangMenuOpen(!isLangMenuOpen)}
                  className="flex items-center space-x-2 px-3 py-2 rounded-lg text-gray-300 hover:text-yellow-500 hover:bg-gray-900/50 transition-all duration-300"
                >
                  <Icons.Globe className="w-5 h-5" />
                  <span className="font-medium">
                    {languages.find(lang => lang.code === currentLang)?.flag || '🇫🇷'}
                  </span>
                  <svg className={`w-4 h-4 transform transition-transform ${isLangMenuOpen ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M7 10l5 5 5-5z"/>
                  </svg>
                </button>

                {/* Menu déroulant des langues */}
                <AnimatePresence>
                  {isLangMenuOpen && (
                    <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      className="absolute top-full right-0 mt-2 w-40 bg-gradient-to-b from-gray-900 to-black rounded-xl shadow-2xl border border-gray-800 overflow-hidden z-50"
                    >
                      {languages.map((lang) => (
                        <button
                          key={lang.code}
                          onClick={() => changeLanguage(lang.code)}
                          className={`w-full flex items-center space-x-3 px-4 py-3 text-left transition-all duration-300 ${currentLang === lang.code
                              ? 'bg-yellow-900/30 text-yellow-500'
                              : 'text-gray-300 hover:text-yellow-500 hover:bg-gray-800/50'
                          }`}
                        >
                          <span className="text-lg">{lang.flag}</span>
                          <span className="font-medium">{lang.name}</span>
                          {currentLang === lang.code && (
                            <div className="ml-auto w-2 h-2 bg-yellow-500 rounded-full"></div>
                          )}
                        </button>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>

              {/* Bouton de soutien */}
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
                className="hidden lg:block"
              >
                <Link
                  to="/support"
                  className="group bg-gradient-to-r from-yellow-600 to-yellow-700 text-white px-6 py-3 rounded-xl font-semibold hover:shadow-2xl hover:shadow-yellow-500/20 transition-all duration-300 flex items-center space-x-2"
                >
                  <Icons.Support className="w-5 h-5" />
                  <span>{t('header.support')}</span>
                </Link>
              </motion.div>

              {/* Sélecteur de langue Mobile (visible seulement sur mobile) */}
              <div className="lg:hidden relative">
                <button
                  onClick={() => setIsLangMenuOpen(!isLangMenuOpen)}
                  className="flex items-center space-x-1 px-3 py-2 rounded-lg text-gray-300 hover:text-yellow-500 hover:bg-gray-900/50 transition-all duration-300"
                >
                  <span className="text-lg">
                    {languages.find(lang => lang.code === currentLang)?.flag || '🇫🇷'}
                  </span>
                </button>

                {/* Menu déroulant des langues mobile */}
                <AnimatePresence>
                  {isLangMenuOpen && (
                    <>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setIsLangMenuOpen(false)}
                        className="fixed inset-0 z-40 lg:hidden"
                      />
                      <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        className="absolute top-full right-0 mt-2 w-40 bg-gradient-to-b from-gray-900 to-black rounded-xl shadow-2xl border border-gray-800 overflow-hidden z-50"
                      >
                        {languages.map((lang) => (
                          <button
                            key={lang.code}
                            onClick={() => changeLanguage(lang.code)}
                            className={`w-full flex items-center space-x-3 px-4 py-3 text-left transition-all duration-300 ${
                              currentLang === lang.code
                                ? 'bg-yellow-900/30 text-yellow-500'
                                : 'text-gray-300 hover:text-yellow-500 hover:bg-gray-800/50'
                            }`}
                          >
                            <span className="text-lg">{lang.flag}</span>
                            <span className="font-medium">{lang.name}</span>
                            {currentLang === lang.code && (
                              <div className="ml-auto w-2 h-2 bg-yellow-500 rounded-full"></div>
                            )}
                          </button>
                        ))}
                      </motion.div>
                    </>
                  )}
                </AnimatePresence>
              </div>

              {/* Bouton Menu Mobile */}
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="lg:hidden p-2 rounded-lg text-gray-300 hover:text-yellow-500 hover:bg-gray-900/50 transition-colors"
                aria-label={isMenuOpen ? t('header.menu.close') : t('header.menu.open')}
              >
                {isMenuOpen ? <Icons.Close /> : <Icons.Menu />}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Espace pour le header fixe */}
      <div className="h-20"></div>

      {/* Menu Mobile */}
      <AnimatePresence>
        {isMenuOpen && (
          <>
            {/* Overlay */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsMenuOpen(false)}
              className="fixed inset-0 bg-black/80 backdrop-blur-sm z-40 lg:hidden"
            />

            {/* Menu Panel */}
            <motion.div
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: 'tween', duration: 0.3 }}
              className="fixed top-0 right-0 bottom-0 w-80 bg-gradient-to-b from-black to-gray-900 border-l border-gray-800 z-50 lg:hidden overflow-y-auto"
            >
              <div className="p-6">
                {/* En-tête du menu mobile */}
                <div className="flex items-center justify-between mb-8">
                  
                  <button
                    onClick={() => setIsMenuOpen(false)}
                    className="p-2 rounded-lg text-gray-300 hover:text-yellow-500 hover:bg-gray-800 transition-colors"
                    aria-label={t('header.menu.close')}
                  >
                    <Icons.Close />
                  </button>
                </div>

                {/* Sélecteur de langue dans le menu mobile */}
                <div className="mb-6">
                  <h3 className="text-sm font-semibold text-gray-400 mb-3">
                    {t('header.mobile.language')}
                  </h3>
                  <div className="grid grid-cols-3 gap-2">
                    {languages.map((lang) => (
                      <button
                        key={lang.code}
                        onClick={() => {
                          changeLanguage(lang.code);
                          setIsMenuOpen(false);
                        }}
                        className={`py-3 rounded-lg flex flex-col items-center justify-center transition-all duration-300 ${
                          currentLang === lang.code
                            ? 'bg-yellow-900/30 text-yellow-500 border-2 border-yellow-500/50'
                            : 'bg-gray-800 text-gray-300 hover:bg-gray-700 hover:text-yellow-500 border border-gray-700'
                        }`}
                      >
                        <span className="text-xl mb-1">{lang.flag}</span>
                        <span className="text-xs font-medium">{lang.name}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Navigation Mobile */}
                <nav className="space-y-2">
                  {navItems.map((item, index) => (
                    <motion.div
                      key={item.path}
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: index * 0.05 }}
                    >
                      <Link
                        to={item.path}
                        onClick={() => setIsMenuOpen(false)}
                        className={`group flex items-center space-x-4 p-4 rounded-xl transition-all duration-300 ${
                          isActive(item.path)
                            ? 'bg-yellow-900/30 text-yellow-500'
                            : 'text-gray-300 hover:text-yellow-500 hover:bg-gray-800/50'
                        }`}
                      >
                        <div className={`p-2 rounded-lg ${
                          isActive(item.path)
                            ? 'bg-yellow-500/20'
                            : 'bg-gray-800 group-hover:bg-yellow-500/20'
                        }`}>
                          {item.icon}
                        </div>
                        <span className="font-medium">{item.label}</span>
                        {isActive(item.path) && (
                          <div className="ml-auto w-2 h-2 bg-yellow-500 rounded-full"></div>
                        )}
                      </Link>
                    </motion.div>
                  ))}
                </nav>

                {/* Section Soutien Mobile */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  className="mt-8 p-6 bg-gradient-to-r from-yellow-900/30 to-yellow-800/20 rounded-2xl border border-yellow-900/30"
                >
                  <h3 className="text-lg font-bold text-white mb-3">
                    {t('header.mobile.support.title')}
                  </h3>
                  <p className="text-gray-300 text-sm mb-4">
                    {t('header.mobile.support.description')}
                  </p>
                  <Link
                    to="/support"
                    onClick={() => setIsMenuOpen(false)}
                    className="block w-full bg-gradient-to-r from-yellow-600 to-yellow-700 text-white text-center py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300"
                  >
                    {t('header.mobile.support.button')}
                  </Link>
                </motion.div>

                {/* Informations de contact */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                  className="mt-8 pt-6 border-t border-gray-800"
                >
                  <h4 className="text-sm font-semibold text-gray-400 mb-3">
                    {t('header.mobile.contact.title')}
                  </h4>
                  <p className="text-gray-300 text-sm mb-2">
                    {t('header.mobile.contact.email')}
                  </p>
                  <p className="text-gray-300 text-sm">
                    {t('header.mobile.contact.follow')}
                  </p>
                  
                  <div className="flex space-x-4 mt-4">
                    {['Facebook', 'YouTube', 'Instagram'].map((social) => (
                      <button
                        key={social}
                        className="text-gray-400 hover:text-yellow-500 transition-colors text-sm"
                      >
                        {social}
                      </button>
                    ))}
                  </div>
                </motion.div>

                {/* Verset */}
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.5 }}
                  className="mt-8 pt-6 border-t border-gray-800"
                >
                  <p className="text-gray-400 text-sm italic text-center">
                    {t('header.mobile.bibleVerse')}
                  </p>
                </motion.div>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;